document.addEventListener('DOMContentLoaded', () => {
  const icon = document.querySelector('#cart-icon-bubble');
  const drawer = document.querySelector('cart-drawer');
  if (!icon || !drawer) return;

  let closeTimeout;

  function openDropdown() {
    clearTimeout(closeTimeout);
    window.dispatchEvent(new Event('openCartDrawer'));
  }

  function scheduleClose() {
    if (typeof drawer.close === 'function') {
      drawer.close();
    }
  }

  icon.addEventListener('mouseenter', openDropdown);

  // icon.addEventListener('mouseleave', scheduleClose);
  // drawer.addEventListener('mouseenter', () => clearTimeout(closeTimeout));
  drawer.addEventListener('mouseleave', scheduleClose);

  // Watch for class changes (open/close)
  const observer = new MutationObserver(() => {
    const isOpen = drawer.classList.contains('active');

    if (isOpen) {
      console.log('Drawer opened');
      // Start 5-second auto-close
      // scheduleClose();
    }
  });

  // Start observing class changes
  observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
});
